import { render } from "./edit-woodpacking.vue?vue&type=template&id=7c388d9d&scoped=true&ts=true"
import script from "./edit-woodpacking.vue?vue&type=script&lang=ts"
export * from "./edit-woodpacking.vue?vue&type=script&lang=ts"

import "./edit-woodpacking.vue?vue&type=style&index=0&id=7c388d9d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c388d9d"]])

export default __exports__